import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryLocationZone = fp.get('inventory.locationZone');

export const getZonesByLocationId = createSelector(
  getInventoryLocationZone,
  fp.get('zonesByLocationId')
);

export const getZonesForLocationId = createSelector(
  (_, id) => id,
  getZonesByLocationId,
  fp.get
);

export const getZonesForLocationIdValues = createSelector(
  getZonesForLocationId,
  fp.pipe(
    fp.values,
    fp.orderBy('createdAt', 'desc')
  )
);

export const getIsFetching = createSelector(
  getInventoryLocationZone,
  fp.get('fetching')
);
export const getIsFetched = createSelector(
  getInventoryLocationZone,
  fp.get('fetched')
);
export const getFetchingError = createSelector(
  getInventoryLocationZone,
  fp.get('fetchingError')
);

export const getIsSaving = createSelector(
  getInventoryLocationZone,
  fp.get('saving')
);
export const getIsSaved = createSelector(
  getInventoryLocationZone,
  fp.get('saved')
);
export const getSavingError = createSelector(
  getInventoryLocationZone,
  fp.get('savingError')
);

export const getIsDeleting = createSelector(
  getInventoryLocationZone,
  fp.get('deleting')
);
export const getIsDeleted = createSelector(
  getInventoryLocationZone,
  fp.get('deleted')
);
export const getDeletingError = createSelector(
  getInventoryLocationZone,
  fp.get('deletingError')
);
